require('./runtime');
(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("./button"), require("./label"), require("./link"), require("./multilinetruncatedtext"), require("./progressindicator"), require("./svgicon"), require("./tooltip"), require("./truncatedtext"), require("./utils"));
	else if(typeof define === 'function' && define.amd)
		define(["./button", "./label", "./link", "./multilinetruncatedtext", "./progressindicator", "./svgicon", "./tooltip", "./truncatedtext", "./utils"], factory);
	else {
		var a = typeof exports === 'object' ? factory(require("./button"), require("./label"), require("./link"), require("./multilinetruncatedtext"), require("./progressindicator"), require("./svgicon"), require("./tooltip"), require("./truncatedtext"), require("./utils")) : factory(root["./button"], root["./label"], root["./link"], root["./multilinetruncatedtext"], root["./progressindicator"], root["./svgicon"], root["./tooltip"], root["./truncatedtext"], root["./utils"]);
		for(var i in a) (typeof exports === 'object' ? exports : root)[i] = a[i];
	}
})(globalThis, (__WEBPACK_EXTERNAL_MODULE__32477__, __WEBPACK_EXTERNAL_MODULE__37394__, __WEBPACK_EXTERNAL_MODULE__85717__, __WEBPACK_EXTERNAL_MODULE__68599__, __WEBPACK_EXTERNAL_MODULE__3142__, __WEBPACK_EXTERNAL_MODULE__56685__, __WEBPACK_EXTERNAL_MODULE__65391__, __WEBPACK_EXTERNAL_MODULE__47511__, __WEBPACK_EXTERNAL_MODULE__78815__) => {
return (globalThis["wpBaUiCarbonToolkit"] = globalThis["wpBaUiCarbonToolkit"] || []).push([[9089],{

/***/ 59327:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";


var _interopRequireDefault = __webpack_require__(97880);
exports.__esModule = true;
exports["default"] = void 0;
var _defineProperty2 = _interopRequireDefault(__webpack_require__(68779));
var _react = _interopRequireWildcard(__webpack_require__(16689));
var _propTypes = _interopRequireDefault(__webpack_require__(580));
var _progressindicator = _interopRequireDefault(__webpack_require__(3142));
var _utils = __webpack_require__(78815);
var _CarbonTile = _interopRequireDefault(__webpack_require__(49842));
var _TileView = _interopRequireDefault(__webpack_require__(90169));
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
/* IBM Confidential
 *
 * OCO Source Materials
 *
 * IBM Cognos Products: ba-ui-common
 * (C) Copyright IBM Corp. 2020, 2023
 *
 * The source code for this program is not published or otherwise
 * divested of its trade secrets, irrespective of what has been
 * deposited with the U.S. Copyright Office.
 * NLS_ENCODING=UTF-8
 * NLS_MESSAGEFORMAT_NONE
 */

const {
  getKeyName,
  keyNames,
  isKey
} = _utils.keyboardUtils;
const tileViewClassName = _TileView.default.tileViewClassName.replace(/"/g, '');
class TileView extends _react.Component {
  constructor(props) {
    super(props);
    (0, _defineProperty2.default)(this, "state", {
      active: 0
    });
    (0, _defineProperty2.default)(this, "_onKeyDown", e => {
      const {
        LEFT,
        RIGHT,
        HOME,
        UP,
        END,
        DOWN
      } = keyNames;
      const {
        active
      } = this.state;
      const {
        length
      } = this.tileRefs;
      let i = active;
      switch (getKeyName(e)) {
        case HOME:
        case UP:
        case LEFT:
          e.preventDefault();
          if (e.altKey || isKey(e, HOME)) {
            if (i === 0) {
              return;
            }
            i = 0;
          } else if (i === -1) {
            i = length - 1;
          } else if (i <= 0) {
            return;
          } else {
            i -= 1;
          }
          break;
        case END:
        case DOWN:
        case RIGHT:
          e.preventDefault();
          if (e.altKey || isKey(e, END)) {
            if (i === length - 1) {
              return;
            }
            i = length - 1;
          } else if (i === -1) {
            i = 0;
          } else if (i >= length - 1) {
            return;
          } else {
            i += 1;
          }
          break;
        default:
          break;
      }
      if (i !== active) {
        this.focus(i);
        this.setState({
          active: i
        });
      }
    });
    this.tileRefs = [];
  }
  _tileRef(index, ref) {
    this.tileRefs[index] = ref;
  }
  focus(index) {
    const {
      active
    } = this.state;
    const i = index === undefined ? active : index;
    this.tileRefs[i].focus();
  }
  render() {
    const {
      className,
      tilesGroup,
      loaded,
      container,
      light
    } = this.props;
    const {
      active
    } = this.state;
    let index = 0;
    let tiles;
    loaded && tilesGroup && tilesGroup.length > 0 && tilesGroup.forEach(group => {
      if (group.tiles.length > 0) {
        tiles = group.tiles.map(tile => {
          const i = index;
          index += 1;
          return /*#__PURE__*/_react.default.createElement(_CarbonTile.default, {
            className: `${tileViewClassName}__tile`,
            container: container,
            key: tile.id,
            selected: tile.selected,
            content: tile,
            onMenu: tile.onMenu ? e => {
              tile.onMenu(e, tile.id);
            } : null,
            removeFromFav: e => {
              tile.removeFromFav(e, tile.id);
            },
            addTofav: e => {
              tile.addTofav(e, tile.id);
            },
            ellipsisIcon: tile.ellipsisIcon,
            ellipsisTooltipLabel: tile.ellipsisTooltipLabel,
            favTooltipLabel: tile.favTooltipLabel,
            onAction: e => {
              tile.openTile(e, tile.id);
            },
            onTileSelect: e => {
              tile.onSelect(e, tile.id);
            },
            dateLabel: tile.dateLabel,
            light: light,
            tabIndex: active === i ? 0 : -1,
            textDir: tile.textDir || 'auto',
            ref: ref => {
              this._tileRef(i, ref);
            }
          });
        });
      }
    });
    return loaded ? /*#__PURE__*/_react.default.createElement("div", {
      className: `${tileViewClassName} ${className}`,
      onKeyDown: this._onKeyDown
    }, tiles ? /*#__PURE__*/_react.default.createElement("div", {
      className: `${tileViewClassName}__asset`
    }, tiles) : null) : /*#__PURE__*/_react.default.createElement("div", {
      className: `${tileViewClassName}__loading`
    }, /*#__PURE__*/_react.default.createElement(_progressindicator.default, {
      size: "large",
      variant: "circle"
    }));
  }
}
exports["default"] = TileView;
(0, _defineProperty2.default)(TileView, "propTypes", {
  /** Custom class name(s) */
  className: _propTypes.default.string,
  /** A list of the tiles formatted properly for use from the ca-ui-toolkit */
  tilesGroup: _propTypes.default.array,
  /** boolean to display progress indicator  */
  loaded: _propTypes.default.bool,
  /** boolean to specify folder or asset  */
  container: _propTypes.default.bool,
  /** boolean to specify tile background color  */
  light: _propTypes.default.bool
});

/***/ }),

/***/ 23514:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";


var _interopRequireDefault = __webpack_require__(97880);
exports.__esModule = true;
var _TileView = _interopRequireDefault(__webpack_require__(59327));
exports["default"] = _TileView.default;
exports.TileView = _TileView.default;
var _CarbonTile = _interopRequireDefault(__webpack_require__(49842));
exports.CarbonTile = _CarbonTile.default;

/***/ }),

/***/ 49842:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";


var _interopRequireDefault = __webpack_require__(97880);
exports.__esModule = true;
exports["default"] = void 0;
var _defineProperty2 = _interopRequireDefault(__webpack_require__(68779));
var _react = _interopRequireWildcard(__webpack_require__(16689));
var _reactDom = __webpack_require__(66405);
var _propTypes = _interopRequireDefault(__webpack_require__(580));
var _baUiCarbon = __webpack_require__(6536);
var _button = _interopRequireDefault(__webpack_require__(32477));
var _svgicon = _interopRequireDefault(__webpack_require__(56685));
var _truncatedtext = _interopRequireDefault(__webpack_require__(47511));
var _multilinetruncatedtext = _interopRequireDefault(__webpack_require__(68599));
var _link = _interopRequireDefault(__webpack_require__(85717));
var _label = _interopRequireDefault(__webpack_require__(37394));
var _tooltip = _interopRequireDefault(__webpack_require__(65391));
var _overflowMenuVertical_ = _interopRequireDefault(__webpack_require__(13421));
var _favorite_ = _interopRequireDefault(__webpack_require__(6390));
var _favoriteFilled_ = _interopRequireDefault(__webpack_require__(27038));
var _folder_ = _interopRequireDefault(__webpack_require__(70001));
var _utils = __webpack_require__(78815);
var _CarbonTile = _interopRequireDefault(__webpack_require__(77029));
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
/* IBM Confidential
 *
 * OCO Source Materials
 *
 * IBM Cognos Products: ba-ui-common
 * (C) Copyright IBM Corp. 2020, 2023
 *
 * The source code for this program is not published or otherwise
 * divested of its trade secrets, irrespective of what has been
 * deposited with the U.S. Copyright Office.
 * NLS_ENCODING=UTF-8
 * NLS_MESSAGEFORMAT_NONE
 */

const {
  getKeyName,
  keyNames
} = _utils.keyboardUtils;
const tileClassName = _CarbonTile.default.tileClassName.replace(/"/g, '');
class CarbonTile extends _react.Component {
  constructor() {
    super(...arguments);
    (0, _defineProperty2.default)(this, "state", {
      hover: false,
      iconHover: false
    });
    (0, _defineProperty2.default)(this, "_onMenu", e => {
      const {
        onMenu
      } = this.props;
      onMenu && onMenu(e);
    });
    (0, _defineProperty2.default)(this, "_onContextMenu", e => {
      const {
        onMenu
      } = this.props;
      e.stopPropagation();
      e.preventDefault();
      if (onMenu) {
        onMenu && onMenu(e);
      }
    });
    (0, _defineProperty2.default)(this, "_onClick", e => {
      e.stopPropagation();
      const {
        onAction
      } = this.props;
      onAction && onAction(e);
    });
    (0, _defineProperty2.default)(this, "_onTileSelect", e => {
      const {
        onTileSelect
      } = this.props;
      onTileSelect && onTileSelect(e);
    });
    (0, _defineProperty2.default)(this, "handleKeyDown", e => {
      const {
        F10,
        ENTER,
        SPACE
      } = keyNames;
      switch (getKeyName(e)) {
        case F10:
          if (e.shiftKey) {
            e.preventDefault();
            this._onMenu(e);
          }
          break;
        case ENTER:
          e.preventDefault();
          this._onClick(e);
          break;
        case SPACE:
          e.preventDefault();
          this._onTileSelect(e);
          break;
        default:
          break;
      }
    });
    (0, _defineProperty2.default)(this, "_onFocus", () => {
      this.setState({
        iconHover: true
      });
    });
    (0, _defineProperty2.default)(this, "_onBlur", () => {
      this.setState({
        iconHover: false
      });
    });
    (0, _defineProperty2.default)(this, "_setHoverState", hover => {
      if (this.hoverDebounce) {
        clearTimeout(this.hoverDebounce);
        this.hoverDebounce = null;
      }
      if (this.state.hover !== hover) {
        this.hoverDebounce = setTimeout(() => {
          this.setState({
            hover
          });
          this.hoverDebounce = null;
        }, 100);
      }
    });
    (0, _defineProperty2.default)(this, "_onMouseEnter", () => {
      this._setHoverState(true);
    });
    (0, _defineProperty2.default)(this, "_onMouseLeave", () => {
      this._setHoverState(false);
    });
  }
  _menuRenderer() {
    const {
      ellipsisIcon
    } = this.props;
    const menu = this.state.hover === true ? /*#__PURE__*/_react.default.createElement("div", {
      className: `${tileClassName}__header__title`
    }, ellipsisIcon || /*#__PURE__*/_react.default.createElement(_button.default, {
      tabIndex: -1,
      onMouseEnter: this._onFocus,
      onMouseLeave: this._onBlur,
      className: `${tileClassName}__header__icon ${this.state.iconHover ? '' : 'hover'}`,
      onClick: this._onMenu,
      onBlur: this._onMouseLeave,
      variant: "icon",
      size: "small",
      icon: _overflowMenuVertical_.default.id,
      title: this.props.ellipsisTooltipLabel,
      "aria-label": this.props.ellipsisTooltipLabel,
      tooltipAlignment: "end"
    })) : null;
    return menu;
  }
  _addLink(content, name) {
    const {
      onAction,
      container
    } = this.props;
    return (
      /*#__PURE__*/
      // eslint-disable-next-line jsx-a11y/anchor-is-valid
      _react.default.createElement(_link.default, {
        style: {
          cursor: 'default',
          width: '80%'
        },
        onContextMenu: this._onContextMenu,
        disabled: content.disabled
      }, container ? name :
      /*#__PURE__*/
      // eslint-disable-next-line jsx-a11y/click-events-have-key-events
      _react.default.createElement("div", {
        onClick: onAction ? this._onClick : null,
        tabIndex: -1
      }, name))
    );
  }
  _favoriteButtonRender(asset, selected) {
    const selectedClassName = selected ? 'selected' : '';
    if (asset.cmObj) {
      const isFav = asset.cmObj.favourite;
      if (isFav) {
        return /*#__PURE__*/_react.default.createElement(_tooltip.default, {
          className: `${tileClassName}__body_fav_button_filled${selectedClassName}`,
          title: this.props.favTooltipLabel,
          orient: "top"
        }, /*#__PURE__*/_react.default.createElement(_svgicon.default, {
          iconId: _favoriteFilled_.default.id,
          title: this.props.favTooltipLabel,
          size: "small",
          onClick: e => this.props.removeFromFav(e)
        }));
      } else {
        return /*#__PURE__*/_react.default.createElement(_tooltip.default, {
          className: `${tileClassName}__body_fav_button${selectedClassName}`,
          title: this.props.favTooltipLabel,
          orient: "top"
        }, /*#__PURE__*/_react.default.createElement(_svgicon.default, {
          iconId: _favorite_.default.id,
          title: this.props.favTooltipLabel,
          size: "small",
          onClick: e => this.props.addTofav(e)
        }));
      }
    }
    return null;
  }
  focus() {
    const tileNode = (0, _reactDom.findDOMNode)(this).nextSibling;
    if (tileNode) {
      tileNode.focus();
    }
  }
  renderFolder(folderProps) {
    var _content$containerLoo;
    const {
      content,
      onMenu,
      ellipsisIcon,
      dateLabel,
      onAction,
      textDir,
      selected
    } = this.props;
    const {
      hover
    } = this.state;
    const containerName = /*#__PURE__*/_react.default.createElement(_truncatedtext.default, {
      className: `${tileClassName}__body__col__label${((_content$containerLoo = content.containerLooksDisabled) != null ? _content$containerLoo : content.disabled) ? ' disabledFolder' : ''}`,
      tooltipDelay: true,
      tabIndex: -1,
      textDir: textDir,
      onClick: onAction ? this._onClick : null,
      title: content.label,
      value: content.label,
      location: "end",
      disabled: content.readOnly || content.disabled
    });
    return /*#__PURE__*/_react.default.createElement(_baUiCarbon.SelectableTile, folderProps, /*#__PURE__*/_react.default.createElement("div", {
      className: `${tileClassName}__folder__content`
    }, /*#__PURE__*/_react.default.createElement(_baUiCarbon.Row, {
      className: `${tileClassName}__body`
    }, /*#__PURE__*/_react.default.createElement(_baUiCarbon.Column, {
      className: `${tileClassName}__body__col`
    }, content.readOnly || content.disabled ? /*#__PURE__*/_react.default.createElement("div", {
      className: `${tileClassName}__readonly`
    }, containerName) : this._addLink(content, containerName), hover ? (onMenu || ellipsisIcon) && this._menuRenderer() : null, content.showFav === true ? this._favoriteButtonRender(content, selected) : null)), /*#__PURE__*/_react.default.createElement(_baUiCarbon.Row, {
      className: `${tileClassName}__folder`
    }, /*#__PURE__*/_react.default.createElement(_baUiCarbon.Column, {
      style: {
        display: 'inline-flex'
      }
    }, /*#__PURE__*/_react.default.createElement(_label.default, {
      label: dateLabel,
      disabled: content.disabled,
      "aria-label": dateLabel,
      className: `${tileClassName}__folder__label`
    }), /*#__PURE__*/_react.default.createElement(_label.default, {
      label: content.date,
      disabled: content.disabled,
      "aria-label": content.disabled,
      className: `${tileClassName}__folder__date`
    })), /*#__PURE__*/_react.default.createElement(_tooltip.default, {
      title: content.type,
      orient: "top",
      style: {
        marginTop: 'auto'
      }
    }, /*#__PURE__*/_react.default.createElement(_svgicon.default, {
      className: `${tileClassName}__folder__icon ${content.color}`,
      iconId: content.iconId ? content.iconId : _folder_.default.id,
      title: content.type,
      disabled: content.disabled
    })))));
  }
  renderAsset(assetProps) {
    const {
      content,
      onMenu,
      ellipsisIcon,
      dateLabel,
      textDir,
      selected
    } = this.props;
    const {
      hover
    } = this.state;
    const assetName = /*#__PURE__*/_react.default.createElement(_multilinetruncatedtext.default, {
      className: `${tileClassName}__body__col__label ${content.disabled ? 'disabled' : ''} ${content.sub_label ? 'has-sublabel' : ''}`,
      tooltipDelay: true,
      title: content.label,
      style: {
        width: '100%',
        whiteSpace: 'nowrap'
      },
      value: content.label,
      numLines: content.sub_label ? 2 : 3,
      disabled: content.disabled
    });
    return /*#__PURE__*/_react.default.createElement(_baUiCarbon.SelectableTile, assetProps, /*#__PURE__*/_react.default.createElement("div", {
      className: `${tileClassName}__content`
    }, /*#__PURE__*/_react.default.createElement(_baUiCarbon.Row, {
      className: `${tileClassName}__body`
    }, /*#__PURE__*/_react.default.createElement(_baUiCarbon.Column, {
      className: `${tileClassName}__body__col`
    }, content.readOnly || content.disabled ? assetName : this._addLink(content, assetName), hover ? (onMenu || ellipsisIcon) && this._menuRenderer() : null, content.showFav === true ? this._favoriteButtonRender(content, selected) : null)), content.sub_label ? /*#__PURE__*/_react.default.createElement(_baUiCarbon.Row, {
      className: `${tileClassName}__sublabel`
    }, /*#__PURE__*/_react.default.createElement(_baUiCarbon.Column, null, /*#__PURE__*/_react.default.createElement(_multilinetruncatedtext.default, {
      className: `${tileClassName}__sublabel__text`,
      tooltipDelay: true,
      title: content.sub_label,
      style: {
        width: '100%',
        whiteSpace: 'nowrap',
        maxWidth: '100%'
      },
      value: content.sub_label,
      numLines: 2,
      disabled: content.disabled
    }))) : null, /*#__PURE__*/_react.default.createElement(_baUiCarbon.Row, {
      className: `${tileClassName}__footer`
    }, /*#__PURE__*/_react.default.createElement(_baUiCarbon.Column, {
      className: `${tileClassName}__footer_col`
    }, /*#__PURE__*/_react.default.createElement(_label.default, {
      label: dateLabel,
      disabled: content.disabled,
      "aria-label": dateLabel,
      className: `${tileClassName}__footer__label`
    }), /*#__PURE__*/_react.default.createElement(_truncatedtext.default, {
      className: `${tileClassName}__footer__date`,
      tooltipDelay: true,
      textDir: textDir,
      title: content.date,
      width: "100%",
      value: content.date,
      disabled: content.disabled,
      allowTooltip: false
    })), content.showTag === true ? /*#__PURE__*/_react.default.createElement(_baUiCarbon.Tag, {
      type: content.color,
      className: `${tileClassName}__footer__tag`,
      disabled: content.disabled || content.hidden
    }, content.type) : null, /*#__PURE__*/_react.default.createElement(_tooltip.default, {
      title: content.type,
      orient: "top"
    }, /*#__PURE__*/_react.default.createElement(_svgicon.default, {
      className: `${tileClassName}__footer__icon ${content.color}`,
      iconId: content.iconId ? content.iconId : _folder_.default.id,
      title: content.type,
      size: "normal",
      disabled: content.disabled
    })))));
  }
  render() {
    const {
      container,
      className,
      selected,
      onMenu,
      size,
      onTileSelect,
      light,
      tabIndex
    } = this.props;
    const {
      hover
    } = this.state;
    const classNames = (0, _utils.classnames)(tileClassName, size, {
      selected,
      container,
      hover: hover && !!onMenu
    });
    const props = {
      selected,
      handleClick: onTileSelect ? this._onTileSelect : null,
      handleKeyDown: this.handleKeyDown,
      onContextMenu: this._onContextMenu,
      onMouseEnter: this._onMouseEnter,
      onMouseLeave: this._onMouseLeave,
      onFocus: this._onMouseEnter,
      onBlur: this._onMouseLeave,
      light,
      tabIndex: tabIndex === undefined ? 0 : tabIndex,
      className: `${classNames} ${className}`
    };
    if (container) {
      return this.renderFolder(props);
    } else {
      return this.renderAsset(props);
    }
  }
}
exports["default"] = CarbonTile;
(0, _defineProperty2.default)(CarbonTile, "propTypes", {
  /** Custom class name(s) */
  className: _propTypes.default.string,
  /** Select folder or asset tile */
  container: _propTypes.default.bool,
  /** Flag to select the tile */
  selected: _propTypes.default.bool,
  /** Data passed to tile */
  content: _propTypes.default.shape({
    type: _propTypes.default.string,
    iconId: _propTypes.default.string,
    label: _propTypes.default.string,
    sub_label: _propTypes.default.string,
    date: _propTypes.default.string,
    showTag: _propTypes.default.bool,
    showFav: _propTypes.default.bool,
    value: _propTypes.default.any,
    disabled: _propTypes.default.bool,
    hidden: _propTypes.default.bool,
    color: _propTypes.default.string,
    readOnly: _propTypes.default.bool,
    containerLooksDisabled: _propTypes.default.bool
  }).isRequired,
  /** Callback function for context menu */
  onMenu: _propTypes.default.func,
  onAction: _propTypes.default.func,
  removeFromFav: _propTypes.default.func,
  addTofav: _propTypes.default.func,
  onTileSelect: _propTypes.default.func,
  /** Svg icon when loading context menu */
  ellipsisIcon: _propTypes.default.element,
  /** ellipsisIcon toop string */
  ellipsisTooltipLabel: _propTypes.default.string,
  /** Data Label to display in footer */
  dateLabel: _propTypes.default.string,
  /** boolean to specify tile background color  */
  light: _propTypes.default.bool,
  favTooltipLabel: _propTypes.default.string,
  tabIndex: _propTypes.default.number,
  textDir: _propTypes.default.string,
  size: _propTypes.default.string
});
(0, _defineProperty2.default)(CarbonTile, "defaultProps", {
  size: 'small',
  container: false,
  selected: false,
  className: '',
  ellipsisTooltipLabel: 'Action menu',
  dateLabel: 'Last modified'
});

/***/ }),

/***/ 43046:
/***/ ((module, exports, __webpack_require__) => {

exports = module.exports = __webpack_require__(98060)(false);
// imports


// module
exports.push([module.id, ".ba-tileView__asset{margin-bottom:1rem;height:auto;width:100%;display:grid;grid-template-columns:repeat(auto-fill, minmax(290px, 1fr));grid-template-rows:auto;grid-gap:1rem}@media all and (-ms-high-contrast: none),(-ms-high-contrast: active){.ba-tileView__asset{display:-ms-flexbox;flex-direction:row;-ms-flex-direction:row;flex-wrap:wrap;-ms-flex-wrap:wrap}.ba-tileView__tile{margin-right:16px;margin-bottom:16px}}.ba-tileView__loading{position:fixed;top:50%;left:50%;display:flex;justify-content:center;align-items:center}", ""]);

// exports
exports.locals = {
	"tileViewClassName": "\"ba-tileView\""
};

/***/ }),

/***/ 16202:
/***/ ((module, exports, __webpack_require__) => {

exports = module.exports = __webpack_require__(98060)(false);
// imports


// module
exports.push([module.id, ".ba-tile.is-container .ba-tile__folder__content .ba-tile__body__col__label,.ba-tile .ba-tile__content .ba-tile__sublabel__text,.ba-tile .ba-tile__content .ba-tile__body__sublabel,.ba-tile .ba-tile__content .ba-tile__body__col__label{font-size:1rem;font-weight:400;line-height:1.25rem}.ba-tile.is-container .ba-tile__folder__date,.ba-tile.is-container .ba-tile__folder__label,.ba-tile.is-container .ba-tile__header,.ba-tile .ba-tile__content .ba-tile__footer__tag,.ba-tile .ba-tile__content .ba-tile__footer__date,.ba-tile .ba-tile__content .ba-tile__footer__label{font-size:.75rem;font-weight:400;line-height:1rem}.ba-tile{height:180px;padding:8px 8px 16px 16px !important;cursor:default}.ba-tile.is-selected{outline-color:#161616;outline-color:hsla(var(--ui-05-h, 0), var(--ui-05-s, 0%), var(--ui-05-l, 8.6274509804%), 1);outline:1px solid;outline-offset:-1px}.ba-tile.is-selected .bx--tile__checkmark{opacity:1}@media all and (-ms-high-contrast: none),(-ms-high-contrast: active){.ba-tile{width:320px}}.ba-tile .ba-tile__content{display:flex;flex-direction:column;justify-content:space-between;height:inherit}.ba-tile .ba-tile__content .ba-tile__header{color:#595859}.ba-tile .ba-tile__content .ba-tile__header__icon{background-color:transparent;padding-right:4px;margin-top:2px}.ba-tile .ba-tile__content .ba-tile__header__icon.hover::before{display:none}.ba-tile .ba-tile__content .ba-tile__header__icon.hover span.bx--assistive-text{display:none}.ba-tile .ba-tile__content .ba-tile__header svg.contextMenuButton{padding-top:0px !important}.ba-tile .ba-tile__content .ba-tile__body{color:#161616;color:hsla(var(--text-01-h, 0), var(--text-01-s, 0%), var(--text-01-l, 8.6274509804%), 1);margin-right:0%}.ba-tile .ba-tile__content .ba-tile__body__col{display:flex;justify-content:space-between;padding-right:0px}.ba-tile .ba-tile__content .ba-tile__body__col__label{padding-top:4px;font-size:1.25rem;font-weight:400;line-height:1.75rem;letter-spacing:0;color:#161616;color:hsla(var(--text-01-h, 0), var(--text-01-s, 0%), var(--text-01-l, 8.6274509804%), 1);cursor:pointer}.ba-tile .ba-tile__content .ba-tile__body__col__label.disabled{pointer-events:none;cursor:not-allowed;color:#8d8d8d;color:hsla(var(--disabled-03-h, 0), var(--disabled-03-s, 0%), var(--disabled-03-l, 55.2941176471%), 1)}.ba-tile .ba-tile__content .ba-tile__body__col__label .ba-common-tooltip>div{display:table;border-bottom:1px solid transparent}.ba-tile .ba-tile__content .ba-tile__body__col__label:hover .ba-common-tooltip>div{display:table;border-bottom:1px solid;border-color:#0353e9}.ba-tile .ba-tile__content .ba-tile__body__sublabel{font-size:.875rem;font-weight:400;line-height:1.25rem;letter-spacing:.16px;max-width:100%}.ba-tile .ba-tile__content .ba-tile__body_fav_button,.ba-tile .ba-tile__content .ba-tile__body_fav_button_filled{margin:10px 6px 0 0;transition:.1s}.ba-tile .ba-tile__content .ba-tile__body_fav_buttonselected,.ba-tile .ba-tile__content .ba-tile__body_fav_button_filledselected{margin:10px 36px 0 0;transition:.1s}.ba-tile .ba-tile__content .ba-tile__sublabel{margin-right:1rem}.ba-tile .ba-tile__content .ba-tile__sublabel__text{font-size:.875rem;font-weight:400;line-height:1.25rem;letter-spacing:.16px;max-width:100%}.ba-tile .ba-tile__content .ba-tile__footer{font-size:.75rem;font-weight:400;line-height:1rem;letter-spacing:.32px;color:#000;margin-right:0%;margin-top:auto}.ba-tile .ba-tile__content .ba-tile__footer__label{margin-right:auto;color:#595859}.ba-tile .ba-tile__content .ba-tile__footer__date{color:#161616;color:hsla(var(--text-01-h, 0), var(--text-01-s, 0%), var(--text-01-l, 8.6274509804%), 1)}.ba-tile .ba-tile__content .ba-tile__footer__tag{height:12px;color:#595859}.ba-tile .ba-tile__content .ba-tile__footer__icon{padding-top:4px;padding-right:4px;fill:#161616}.ba-tile .ba-tile__content .ba-tile__footer__icon.purple{fill:#a56eff}.ba-tile .ba-tile__content .ba-tile__footer__icon.blue{fill:#4589ff}.ba-tile .ba-tile__content .ba-tile__footer__icon.teal{fill:#009d9a}.ba-tile .ba-tile__content .ba-common-tags__list{align-items:flex-end}.ba-tile:focus{outline:2px solid #0353e9;outline-offset:-2px;background-color:#e5e5e5}.ba-tile.is-hover .ba-tile__body__col__label{color:#0f62fe;color:hsla(var(--link-01-h, 219.1631799163), var(--link-01-s, 99.1701244813%), var(--link-01-l, 52.7450980392%), 1)}.ba-tile.is-container{height:90px;padding:8px 8px 16px 16px !important;cursor:default}@media all and (-ms-high-contrast: none),(-ms-high-contrast: active){.ba-tile.is-container{width:320px}}.ba-tile.is-container .ba-tile__folder__content{display:flex;flex-direction:column;justify-content:space-between;height:inherit}.ba-tile.is-container .ba-tile__folder__content .ba-tile__body{color:#161616;color:hsla(var(--text-01-h, 0), var(--text-01-s, 0%), var(--text-01-l, 8.6274509804%), 1);margin-right:0%}.ba-tile.is-container .ba-tile__folder__content .ba-tile__body__col{display:flex;justify-content:space-between;padding-right:0px}.ba-tile.is-container .ba-tile__folder__content .ba-tile__body__col>a:hover{text-decoration:none}.ba-tile.is-container .ba-tile__folder__content .ba-tile__body__col__label{cursor:pointer;padding-top:4px;font-size:1.25rem;font-weight:400;line-height:1.75rem;letter-spacing:0;color:#161616;color:hsla(var(--text-01-h, 0), var(--text-01-s, 0%), var(--text-01-l, 8.6274509804%), 1);margin-bottom:8px;max-width:100%;border-bottom:1px solid transparent}.ba-tile.is-container .ba-tile__folder__content .ba-tile__body__col__label:hover{border-bottom:1px solid;border-color:#0353e9}.ba-tile.is-container .ba-tile__folder__content .ba-tile__body__col__label.disabledFolder{color:#8d8d8d;color:hsla(var(--disabled-03-h, 0), var(--disabled-03-s, 0%), var(--disabled-03-l, 55.2941176471%), 1);cursor:pointer}.ba-tile.is-container .ba-tile__folder__content .ba-tile__body__col__label.disabledFolder:hover{border-color:#8d8d8d}.ba-tile.is-container .ba-tile__folder__content .ba-tile__body_fav_button,.ba-tile.is-container .ba-tile__folder__content .ba-tile__body_fav_button_filled{margin:10px 6px 0 0;transition:.1s}.ba-tile.is-container .ba-tile__folder__content .ba-tile__body_fav_buttonselected,.ba-tile.is-container .ba-tile__folder__content .ba-tile__body_fav_button_filledselected{margin:10px 36px 0 0;transition:.1s}.ba-tile.is-container .ba-tile__folder__content .ba-tile__body .ba-tile__readonly{cursor:default;width:80%}.ba-tile.is-container .ba-tile__header{color:#595859}.ba-tile.is-container .ba-tile__header__icon{background-color:transparent;padding-right:4px;margin-top:2px}.ba-tile.is-container .ba-tile__header__icon.hover::before{display:none}.ba-tile.is-container .ba-tile__header__icon.hover span.bx--assistive-text{display:none}.ba-tile.is-container .ba-tile__header svg.contextMenuButton{padding-top:0px !important}.ba-tile.is-container .ba-tile__folder{color:#161616;color:hsla(var(--text-01-h, 0), var(--text-01-s, 0%), var(--text-01-l, 8.6274509804%), 1);font-size:.75rem;font-weight:400;line-height:1rem;letter-spacing:.32px;margin-top:auto;margin-right:0%}.ba-tile.is-container .ba-tile__folder__label{color:#595859;margin-top:auto;display:flex}.ba-tile.is-container .ba-tile__folder__date{color:#161616;color:hsla(var(--text-01-h, 0), var(--text-01-s, 0%), var(--text-01-l, 8.6274509804%), 1);margin-top:auto;margin-left:4px}.ba-tile.is-container .ba-tile__folder__icon{margin-top:auto;padding-top:4px;padding-right:4px;fill:#161616}.ba-tile.is-container .ba-tile__folder__icon.purple{fill:#a56eff}.ba-tile.is-container .ba-tile__folder__icon.blue{fill:#4589ff}.ba-tile.is-container .ba-tile__folder__icon.teal{fill:#009d9a}.ba-tile.is-container:focus{outline:2px solid #0353e9;outline-offset:-2px;background-color:#e5e5e5}.ba-tile.is-container.is-hover .ba-tile__body__col__label{color:#0f62fe;color:hsla(var(--link-01-h, 219.1631799163), var(--link-01-s, 99.1701244813%), var(--link-01-l, 52.7450980392%), 1)}", ""]);

// exports
exports.locals = {
	"tileClassName": "\"ba-tile\""
};

/***/ }),

/***/ 90169:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var _node_modules_style_loader_dist_runtime_injectStylesIntoStyleTag_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(93379);
/* harmony import */ var _node_modules_style_loader_dist_runtime_injectStylesIntoStyleTag_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_style_loader_dist_runtime_injectStylesIntoStyleTag_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _node_modules_style_loader_dist_runtime_styleDomAPI_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(7795);
/* harmony import */ var _node_modules_style_loader_dist_runtime_styleDomAPI_js__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_node_modules_style_loader_dist_runtime_styleDomAPI_js__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _node_modules_style_loader_dist_runtime_insertBySelector_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(90569);
/* harmony import */ var _node_modules_style_loader_dist_runtime_insertBySelector_js__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(_node_modules_style_loader_dist_runtime_insertBySelector_js__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _node_modules_style_loader_dist_runtime_setAttributesWithoutAttributes_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(3565);
/* harmony import */ var _node_modules_style_loader_dist_runtime_setAttributesWithoutAttributes_js__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(_node_modules_style_loader_dist_runtime_setAttributesWithoutAttributes_js__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _node_modules_style_loader_dist_runtime_insertStyleElement_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(19216);
/* harmony import */ var _node_modules_style_loader_dist_runtime_insertStyleElement_js__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(_node_modules_style_loader_dist_runtime_insertStyleElement_js__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var _node_modules_style_loader_dist_runtime_styleTagTransform_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(44589);
/* harmony import */ var _node_modules_style_loader_dist_runtime_styleTagTransform_js__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(_node_modules_style_loader_dist_runtime_styleTagTransform_js__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var _node_modules_css_loader_index_js_node_modules_sass_loader_dist_cjs_js_ruleSet_1_rules_1_use_2_TileView_scss__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(43046);
/* harmony import */ var _node_modules_css_loader_index_js_node_modules_sass_loader_dist_cjs_js_ruleSet_1_rules_1_use_2_TileView_scss__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(_node_modules_css_loader_index_js_node_modules_sass_loader_dist_cjs_js_ruleSet_1_rules_1_use_2_TileView_scss__WEBPACK_IMPORTED_MODULE_6__);
/* harmony reexport (unknown) */ var __WEBPACK_REEXPORT_OBJECT__ = {};
/* harmony reexport (unknown) */ for(const __WEBPACK_IMPORT_KEY__ in _node_modules_css_loader_index_js_node_modules_sass_loader_dist_cjs_js_ruleSet_1_rules_1_use_2_TileView_scss__WEBPACK_IMPORTED_MODULE_6__) if(__WEBPACK_IMPORT_KEY__ !== "default") __WEBPACK_REEXPORT_OBJECT__[__WEBPACK_IMPORT_KEY__] = () => _node_modules_css_loader_index_js_node_modules_sass_loader_dist_cjs_js_ruleSet_1_rules_1_use_2_TileView_scss__WEBPACK_IMPORTED_MODULE_6__[__WEBPACK_IMPORT_KEY__]
/* harmony reexport (unknown) */ __webpack_require__.d(__webpack_exports__, __WEBPACK_REEXPORT_OBJECT__);

      
      
      
      
      
      
      
      
      

var options = {};

options.styleTagTransform = (_node_modules_style_loader_dist_runtime_styleTagTransform_js__WEBPACK_IMPORTED_MODULE_5___default());
options.setAttributes = (_node_modules_style_loader_dist_runtime_setAttributesWithoutAttributes_js__WEBPACK_IMPORTED_MODULE_3___default());

      options.insert = _node_modules_style_loader_dist_runtime_insertBySelector_js__WEBPACK_IMPORTED_MODULE_2___default().bind(null, "head");
    
options.domAPI = (_node_modules_style_loader_dist_runtime_styleDomAPI_js__WEBPACK_IMPORTED_MODULE_1___default());
options.insertStyleElement = (_node_modules_style_loader_dist_runtime_insertStyleElement_js__WEBPACK_IMPORTED_MODULE_4___default());

var update = _node_modules_style_loader_dist_runtime_injectStylesIntoStyleTag_js__WEBPACK_IMPORTED_MODULE_0___default()((_node_modules_css_loader_index_js_node_modules_sass_loader_dist_cjs_js_ruleSet_1_rules_1_use_2_TileView_scss__WEBPACK_IMPORTED_MODULE_6___default()), options);




       /* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = ((_node_modules_css_loader_index_js_node_modules_sass_loader_dist_cjs_js_ruleSet_1_rules_1_use_2_TileView_scss__WEBPACK_IMPORTED_MODULE_6___default()) && (_node_modules_css_loader_index_js_node_modules_sass_loader_dist_cjs_js_ruleSet_1_rules_1_use_2_TileView_scss__WEBPACK_IMPORTED_MODULE_6___default().locals) ? (_node_modules_css_loader_index_js_node_modules_sass_loader_dist_cjs_js_ruleSet_1_rules_1_use_2_TileView_scss__WEBPACK_IMPORTED_MODULE_6___default().locals) : undefined);


/***/ }),

/***/ 77029:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var _node_modules_style_loader_dist_runtime_injectStylesIntoStyleTag_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(93379);
/* harmony import */ var _node_modules_style_loader_dist_runtime_injectStylesIntoStyleTag_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_style_loader_dist_runtime_injectStylesIntoStyleTag_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _node_modules_style_loader_dist_runtime_styleDomAPI_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(7795);
/* harmony import */ var _node_modules_style_loader_dist_runtime_styleDomAPI_js__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_node_modules_style_loader_dist_runtime_styleDomAPI_js__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _node_modules_style_loader_dist_runtime_insertBySelector_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(90569);
/* harmony import */ var _node_modules_style_loader_dist_runtime_insertBySelector_js__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(_node_modules_style_loader_dist_runtime_insertBySelector_js__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _node_modules_style_loader_dist_runtime_setAttributesWithoutAttributes_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(3565);
/* harmony import */ var _node_modules_style_loader_dist_runtime_setAttributesWithoutAttributes_js__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(_node_modules_style_loader_dist_runtime_setAttributesWithoutAttributes_js__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _node_modules_style_loader_dist_runtime_insertStyleElement_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(19216);
/* harmony import */ var _node_modules_style_loader_dist_runtime_insertStyleElement_js__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(_node_modules_style_loader_dist_runtime_insertStyleElement_js__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var _node_modules_style_loader_dist_runtime_styleTagTransform_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(44589);
/* harmony import */ var _node_modules_style_loader_dist_runtime_styleTagTransform_js__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(_node_modules_style_loader_dist_runtime_styleTagTransform_js__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var _node_modules_css_loader_index_js_node_modules_sass_loader_dist_cjs_js_ruleSet_1_rules_1_use_2_CarbonTile_scss__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(16202);
/* harmony import */ var _node_modules_css_loader_index_js_node_modules_sass_loader_dist_cjs_js_ruleSet_1_rules_1_use_2_CarbonTile_scss__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(_node_modules_css_loader_index_js_node_modules_sass_loader_dist_cjs_js_ruleSet_1_rules_1_use_2_CarbonTile_scss__WEBPACK_IMPORTED_MODULE_6__);
/* harmony reexport (unknown) */ var __WEBPACK_REEXPORT_OBJECT__ = {};
/* harmony reexport (unknown) */ for(const __WEBPACK_IMPORT_KEY__ in _node_modules_css_loader_index_js_node_modules_sass_loader_dist_cjs_js_ruleSet_1_rules_1_use_2_CarbonTile_scss__WEBPACK_IMPORTED_MODULE_6__) if(__WEBPACK_IMPORT_KEY__ !== "default") __WEBPACK_REEXPORT_OBJECT__[__WEBPACK_IMPORT_KEY__] = () => _node_modules_css_loader_index_js_node_modules_sass_loader_dist_cjs_js_ruleSet_1_rules_1_use_2_CarbonTile_scss__WEBPACK_IMPORTED_MODULE_6__[__WEBPACK_IMPORT_KEY__]
/* harmony reexport (unknown) */ __webpack_require__.d(__webpack_exports__, __WEBPACK_REEXPORT_OBJECT__);

      
      
      
      
      
      
      
      
      

var options = {};

options.styleTagTransform = (_node_modules_style_loader_dist_runtime_styleTagTransform_js__WEBPACK_IMPORTED_MODULE_5___default());
options.setAttributes = (_node_modules_style_loader_dist_runtime_setAttributesWithoutAttributes_js__WEBPACK_IMPORTED_MODULE_3___default());

      options.insert = _node_modules_style_loader_dist_runtime_insertBySelector_js__WEBPACK_IMPORTED_MODULE_2___default().bind(null, "head");
    
options.domAPI = (_node_modules_style_loader_dist_runtime_styleDomAPI_js__WEBPACK_IMPORTED_MODULE_1___default());
options.insertStyleElement = (_node_modules_style_loader_dist_runtime_insertStyleElement_js__WEBPACK_IMPORTED_MODULE_4___default());

var update = _node_modules_style_loader_dist_runtime_injectStylesIntoStyleTag_js__WEBPACK_IMPORTED_MODULE_0___default()((_node_modules_css_loader_index_js_node_modules_sass_loader_dist_cjs_js_ruleSet_1_rules_1_use_2_CarbonTile_scss__WEBPACK_IMPORTED_MODULE_6___default()), options);




       /* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = ((_node_modules_css_loader_index_js_node_modules_sass_loader_dist_cjs_js_ruleSet_1_rules_1_use_2_CarbonTile_scss__WEBPACK_IMPORTED_MODULE_6___default()) && (_node_modules_css_loader_index_js_node_modules_sass_loader_dist_cjs_js_ruleSet_1_rules_1_use_2_CarbonTile_scss__WEBPACK_IMPORTED_MODULE_6___default().locals) ? (_node_modules_css_loader_index_js_node_modules_sass_loader_dist_cjs_js_ruleSet_1_rules_1_use_2_CarbonTile_scss__WEBPACK_IMPORTED_MODULE_6___default().locals) : undefined);


/***/ }),

/***/ 93379:
/***/ ((module) => {

"use strict";


var stylesInDOM = [];
function getIndexByIdentifier(identifier) {
  var result = -1;
  for (var i = 0; i < stylesInDOM.length; i++) {
    if (stylesInDOM[i].identifier === identifier) {
      result = i;
      break;
    }
  }
  return result;
}
function modulesToDom(list, options) {
  var idCountMap = {};
  var identifiers = [];
  for (var i = 0; i < list.length; i++) {
    var item = list[i];
    var id = options.base ? item[0] + options.base : item[0];
    var count = idCountMap[id] || 0;
    var identifier = "".concat(id, " ").concat(count);
    idCountMap[id] = count + 1;
    var indexByIdentifier = getIndexByIdentifier(identifier);
    var obj = {
      css: item[1],
      media: item[2],
      sourceMap: item[3],
      supports: item[4],
      layer: item[5]
    };
    if (indexByIdentifier !== -1) {
      stylesInDOM[indexByIdentifier].references++;
      stylesInDOM[indexByIdentifier].updater(obj);
    } else {
      var updater = addElementStyle(obj, options);
      options.byIndex = i;
      stylesInDOM.splice(i, 0, {
        identifier: identifier,
        updater: updater,
        references: 1
      });
    }
    identifiers.push(identifier);
  }
  return identifiers;
}
function addElementStyle(obj, options) {
  var api = options.domAPI(options);
  api.update(obj);
  var updater = function updater(newObj) {
    if (newObj) {
      if (newObj.css === obj.css && newObj.media === obj.media && newObj.sourceMap === obj.sourceMap && newObj.supports === obj.supports && newObj.layer === obj.layer) {
        return;
      }
      api.update(obj = newObj);
    } else {
      api.remove();
    }
  };
  return updater;
}
module.exports = function (list, options) {
  options = options || {};
  list = list || [];
  var lastIdentifiers = modulesToDom(list, options);
  return function update(newList) {
    newList = newList || [];
    for (var i = 0; i < lastIdentifiers.length; i++) {
      var identifier = lastIdentifiers[i];
      var index = getIndexByIdentifier(identifier);
      stylesInDOM[index].references--;
    }
    var newLastIdentifiers = modulesToDom(newList, options);
    for (var _i = 0; _i < lastIdentifiers.length; _i++) {
      var _identifier = lastIdentifiers[_i];
      var _index = getIndexByIdentifier(_identifier);
      if (stylesInDOM[_index].references === 0) {
        stylesInDOM[_index].updater();
        stylesInDOM.splice(_index, 1);
      }
    }
    lastIdentifiers = newLastIdentifiers;
  };
};

/***/ }),

/***/ 90569:
/***/ ((module) => {

"use strict";


var memo = {};

/* istanbul ignore next  */
function getTarget(target) {
  if (typeof memo[target] === "undefined") {
    var styleTarget = document.querySelector(target);

    // Special case to return head of iframe instead of iframe itself
    if (window.HTMLIFrameElement && styleTarget instanceof window.HTMLIFrameElement) {
      try {
        // This will throw an exception if access to iframe is blocked
        // due to cross-origin restrictions
        styleTarget = styleTarget.contentDocument.head;
      } catch (e) {
        // istanbul ignore next
        styleTarget = null;
      }
    }
    memo[target] = styleTarget;
  }
  return memo[target];
}

/* istanbul ignore next  */
function insertBySelector(insert, style) {
  var target = getTarget(insert);
  if (!target) {
    throw new Error("Couldn't find a style target. This probably means that the value for the 'insert' parameter is invalid.");
  }
  target.appendChild(style);
}
module.exports = insertBySelector;

/***/ }),

/***/ 19216:
/***/ ((module) => {

"use strict";


/* istanbul ignore next  */
function insertStyleElement(options) {
  var element = document.createElement("style");
  options.setAttributes(element, options.attributes);
  options.insert(element, options.options);
  return element;
}
module.exports = insertStyleElement;

/***/ }),

/***/ 3565:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";


/* istanbul ignore next  */
function setAttributesWithoutAttributes(styleElement) {
  var nonce =  true ? __webpack_require__.nc : 0;
  if (nonce) {
    styleElement.setAttribute("nonce", nonce);
  }
}
module.exports = setAttributesWithoutAttributes;

/***/ }),

/***/ 7795:
/***/ ((module) => {

"use strict";


/* istanbul ignore next  */
function apply(styleElement, options, obj) {
  var css = "";
  if (obj.supports) {
    css += "@supports (".concat(obj.supports, ") {");
  }
  if (obj.media) {
    css += "@media ".concat(obj.media, " {");
  }
  var needLayer = typeof obj.layer !== "undefined";
  if (needLayer) {
    css += "@layer".concat(obj.layer.length > 0 ? " ".concat(obj.layer) : "", " {");
  }
  css += obj.css;
  if (needLayer) {
    css += "}";
  }
  if (obj.media) {
    css += "}";
  }
  if (obj.supports) {
    css += "}";
  }
  var sourceMap = obj.sourceMap;
  if (sourceMap && typeof btoa !== "undefined") {
    css += "\n/*# sourceMappingURL=data:application/json;base64,".concat(btoa(unescape(encodeURIComponent(JSON.stringify(sourceMap)))), " */");
  }

  // For old IE
  /* istanbul ignore if  */
  options.styleTagTransform(css, styleElement, options.options);
}
function removeStyleElement(styleElement) {
  // istanbul ignore if
  if (styleElement.parentNode === null) {
    return false;
  }
  styleElement.parentNode.removeChild(styleElement);
}

/* istanbul ignore next  */
function domAPI(options) {
  if (typeof document === "undefined") {
    return {
      update: function update() {},
      remove: function remove() {}
    };
  }
  var styleElement = options.insertStyleElement(options);
  return {
    update: function update(obj) {
      apply(styleElement, options, obj);
    },
    remove: function remove() {
      removeStyleElement(styleElement);
    }
  };
}
module.exports = domAPI;

/***/ }),

/***/ 44589:
/***/ ((module) => {

"use strict";


/* istanbul ignore next  */
function styleTagTransform(css, styleElement) {
  if (styleElement.styleSheet) {
    styleElement.styleSheet.cssText = css;
  } else {
    while (styleElement.firstChild) {
      styleElement.removeChild(styleElement.firstChild);
    }
    styleElement.appendChild(document.createTextNode(css));
  }
}
module.exports = styleTagTransform;

/***/ }),

/***/ 27038:
/***/ ((module) => {

"use strict";
module.exports = require("@ba/ba-graphics/dist/icons-js/favorite--filled_32");

/***/ }),

/***/ 6390:
/***/ ((module) => {

"use strict";
module.exports = require("@ba/ba-graphics/dist/icons-js/favorite_32");

/***/ }),

/***/ 70001:
/***/ ((module) => {

"use strict";
module.exports = require("@ba/ba-graphics/dist/icons-js/folder_32");

/***/ }),

/***/ 13421:
/***/ ((module) => {

"use strict";
module.exports = require("@ba/ba-graphics/dist/icons-js/overflow-menu--vertical_32.js");

/***/ }),

/***/ 6536:
/***/ ((module) => {

"use strict";
module.exports = require("@ba/ba-ui-carbon");

/***/ }),

/***/ 68779:
/***/ ((module) => {

"use strict";
module.exports = require("@babel/runtime/helpers/defineProperty");

/***/ }),

/***/ 97880:
/***/ ((module) => {

"use strict";
module.exports = require("@babel/runtime/helpers/interopRequireDefault");

/***/ }),

/***/ 98060:
/***/ ((module) => {

"use strict";
module.exports = require("css-loader/lib/css-base");

/***/ }),

/***/ 580:
/***/ ((module) => {

"use strict";
module.exports = require("prop-types");

/***/ }),

/***/ 16689:
/***/ ((module) => {

"use strict";
module.exports = require("react");

/***/ }),

/***/ 66405:
/***/ ((module) => {

"use strict";
module.exports = require("react-dom");

/***/ }),

/***/ 32477:
/***/ ((module) => {

"use strict";
module.exports = __WEBPACK_EXTERNAL_MODULE__32477__;

/***/ }),

/***/ 37394:
/***/ ((module) => {

"use strict";
module.exports = __WEBPACK_EXTERNAL_MODULE__37394__;

/***/ }),

/***/ 85717:
/***/ ((module) => {

"use strict";
module.exports = __WEBPACK_EXTERNAL_MODULE__85717__;

/***/ }),

/***/ 68599:
/***/ ((module) => {

"use strict";
module.exports = __WEBPACK_EXTERNAL_MODULE__68599__;

/***/ }),

/***/ 3142:
/***/ ((module) => {

"use strict";
module.exports = __WEBPACK_EXTERNAL_MODULE__3142__;

/***/ }),

/***/ 56685:
/***/ ((module) => {

"use strict";
module.exports = __WEBPACK_EXTERNAL_MODULE__56685__;

/***/ }),

/***/ 65391:
/***/ ((module) => {

"use strict";
module.exports = __WEBPACK_EXTERNAL_MODULE__65391__;

/***/ }),

/***/ 47511:
/***/ ((module) => {

"use strict";
module.exports = __WEBPACK_EXTERNAL_MODULE__47511__;

/***/ }),

/***/ 78815:
/***/ ((module) => {

"use strict";
module.exports = __WEBPACK_EXTERNAL_MODULE__78815__;

/***/ })

},
/******/ __webpack_require__ => { // webpackRuntimeModules
/******/ var __webpack_exec__ = (moduleId) => (__webpack_require__(__webpack_require__.s = moduleId))
/******/ var __webpack_exports__ = (__webpack_exec__(23514));
/******/ return __webpack_exports__;
/******/ }
]);
});